import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DevTestingComponent } from './dev-testing/dev-testing.component';

@NgModule({
    declarations: [DevTestingComponent],
    imports: [CommonModule],
    exports: [DevTestingComponent]
})
export class DevTestingModule {}
